import { useQuery } from 'react-query';
import { DjangoListResponse, Contact } from 'v2/models';
import restFactory from 'v2/utils/restFactory';
import { IAppliedFilter } from 'v2/common/ComposeFilters/filters';
import { getQueryParametersFromAppliedFilters } from 'v2/common/ComposeFilters/utils';

export interface IUseContactsParams {
  page?: number;
  searchText?: string;
  filters?: IAppliedFilter[];
}

export function getContactListQueryKey(options: IUseContactsParams = {}) {
  return ['ContactsList', ...(options ? [options] : [])];
}

export function useContacts({ page, searchText, filters }: IUseContactsParams) {
  const result = useQuery(
    getContactListQueryKey({ page, searchText, filters }),
    async () => {
      return await restFactory.get<DjangoListResponse<Contact>>(
        `/dj/api/v1/contact/`,
        {
          page: page,
          search: searchText,
          ...getQueryParametersFromAppliedFilters(filters),
        }
      );
    },
    {
      cacheTime: 0,
    }
  );

  return result;
}
